import api from "../api";
import {ElMessage} from "element-plus";

export default {
    namespaced: true,
    state: {
        notifications: {data: [], current_page: 1, total: 0, per_page: 10},
        loading: false,
        errors: {
            data: {
                errors: {
                    name: [],
                    category: [],
                    color: []
                }
            }
        },
        has_errors: false,
        dialogVisible: false,
    },
    getters: {
        loading: state => state.loading,
        dialogVisible: state => state.dialogVisible,
        notifications: state => state.notifications,
        errors: state => state.errors,
        has_errors: state => state.has_errors,
    },
    mutations: {
        setLoading(state, val) {
            state.loading = val
        },
        setDialogVisible(state, status) {
            state.dialogVisible = status;
        },
        setNotifications(state, data) {
            state.notifications = data;
        },
        setErrors(state, errors) {
            state.errors = errors
        },
        hasErrors(state, val) {
            state.has_errors = val
            if (!val) {
                state.errors = {
                    data: {
                        errors: {
                            name: [],
                            category: [],
                            color: []
                        }
                    }
                };
            }
        }
    },
    actions: {
        async openDialogVisible({commit}, status) {
            commit('setDialogVisible', status);
        },

        async getNotifications({commit}, filters) {
            try {
                commit('setLoading', false);
                const response = await api.getNotifications(filters);
                commit('setNotifications', response);
                commit('setLoading', false);
            } catch (e) {
                ElMessage.error(e.response.data.message);
            }
        },

        async editNotification({dispatch, commit}, data) {
            try {
                commit('setLoading', true)
                commit('hasErrors', false)
                await api.editNotification(data);
                dispatch('getNotifications', {
                    paginate: true
                });
                ElMessage.success('Information updated successfully.');
                commit('setLoading', false)
                commit('setDialogVisible', false)
            } catch (e) {
                commit('setLoading', false);
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error(e.response.data.message);
            }
        },
        async markAsRead({dispatch, commit}, data) {
            try {
                commit('setLoading', true)
                commit('hasErrors', false)
                await api.markAsRead(data);
                dispatch('getNotifications', {});
                ElMessage.success('Information updated successfully.');
                commit('setLoading', false)
                commit('setDialogVisible', false)
            } catch (e) {
                commit('setLoading', false);
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error(e.response.data.message);
            }
        },
    }
}
